import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/auth";
import { UsersService } from '../../Services/users.service';

@Component({
  selector: 'app-signup-successful',
  templateUrl: './signup-successful.component.html',
  styleUrls: ['./signup-successful.component.scss']
})
export class SignupSuccessfulComponent implements OnInit {
  authSub;
  alertType = "";
  alertMsg = "";
  showAlert = false;
  isEmailSent = false;
  constructor(public afAuth: AngularFireAuth, private usersService: UsersService) { }

  ngOnInit() {
  }

  async resendVerificationEmail() {
    try {
    let user = await this.checkAuthenticationStatus();
    this.usersService
      .sendVerificationEmail((<any>user).email, (<any>user).displayName, (<any>user).uid)
      .subscribe(
        (response) => {
          this.isEmailSent = true;
          this.showAlertToUser('success', "Verification email sent successfully.");
        },
        (error) => {
          this.showAlertToUser('danger', "Could not send the verification email right now. We will try again. Please check your email a little later, or contact support.");}
      );
    } catch (e) {
      this.showAlertToUser('danger', "Could not send the verification email right now. We will try again. Please check your email a little later, or contact support.");
    };
    
  }

  /**
   * Get the user id if authenticated user is found
   */
  checkAuthenticationStatus() {
    return new Promise((resolve, reject) => {
      this.authSub = this.afAuth.user.subscribe((user) => {
        if (user) {
          resolve(user);
        } else {
          reject(false);
        }
      });
    });
  }

  showAlertToUser(type, message) {
    this.showAlert = true;
    this.alertType = type;
    this.alertMsg = message;
  }

  onAlertClosed(alert) {
    this.showAlert = false;
  }

}
